export const myLeaveMyFulfilledLeavesTableDef = {
  id: "my-leave-my-fulfilled-leaves-table-def",
  select: "none",
  columns: [
    {
      align: "left",
      id: "startDate",
      label: "OC_START_TIME",
      sort: true,
      type: "date",
      width: "120px",
    },
    {
      align: "left",
      id: "endDate",
      label: "OC_END_TIME",
      sort: true,
      type: "date",
      width: "120px",
    },
    {
      align: "right",
      id: "effectiveWorkDays",
      label: "MY_LEAVE_ABBREVIATED_WORKDAYS",
      sort: true,
      type: "text",
      width: "80px",
    },
    {
      align: "left",
      id: "type",
      label: "OC_TYPE",
      sort: true,
      filter: true,
      type: "localizedName",
      width: "auto",
      minWidth: "144px",
    },
  ],
};

export const myLeaveMyFulfilledLeavesMobileTableDef = {
  id: "my-leave-my-fulfilled-leaves-mobile-table-def",
  select: "row",
  columns: [
    {
      align: "left",
      id: "startDate",
      label: "OC_START_TIME",
      sort: true,
      type: "date",
      width: "120px",
    },
    {
      align: "left",
      id: "endDate",
      label: "OC_END_TIME",
      sort: true,
      type: "date",
      width: "120px",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myLeavePreviousFulfilledLeavesTableDef = {
  id: "my-leave-previous-fulfilled-leaves-table-def",
  select: "row",
  columns: [
    {
      align: "left",
      id: "year",
      label: "OC_YEAR",
      sort: true,
      type: "text",
      width: "60px",
    },
    {
      align: "right",
      id: "fulfilledLeave",
      label: "MY_LEAVE_FULFILLED_BASE_LEAVE",
      sort: true,
      type: "text",
      width: "auto",
    },
    {
      align: "right",
      id: "fulfilledAbsence",
      label: "MY_LEAVE_FULFILLED_ABSENCE",
      sort: true,
      width: "auto",
    },
  ],
};

export const previousFulfilledLeavesisMobile = {
  id: "my-previous-fulfilled-leaves-table",
  select: "row",
  columns: [
    {
      align: "left",
      id: "year",
      label: "OC_YEAR",
      sort: true,
      type: "text",
      width: "60px",
    },
    {
      align: "right",
      id: "fulfilledLeave",
      label: "MY_LEAVE_FULFILLED_BASE_LEAVE",
      sort: true,
      type: "text",
      width: "auto",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const allLeaveRequests = {
  id: "all-leave-requests-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: true,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      sort: true,
    },
    {
      id: "leaveBadges",
      type: "leaveBadges",
      label: "OC_REQUEST",
      width: "120px",
      filter: true,
    },
  ],
};

export const allLeaveRequestsIsMobile = {
  id: "all-leave-requests-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "leaveBadges",
      type: "leaveBadges",
      label: "OC_REQUEST",
      filter: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myLeaveRequests = {
  id: "employees-list-table",
  select: "row",
  columns: [
    {
      id: "leaveTypeName",
      type: "leaveTypeName",
      label: "OC_TYPE",
      sort: true,
    },
    {
      id: "period",
      type: "text",
      label: "OC_PERIOD",
      sort: true,
    },
    {
      id: "effectiveWorkDays",
      type: "text",
      label: "MY_LEAVE_ABBREVIATED_WORKDAYS",
      align: "right",
      sort: true,
      width: "100px",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
      sort: true,
      filter: true,
    },
    {
      id: "createdAt",
      type: "text",
      label: "OC_REQUEST_CREATED_AT",
      sort: true,
    },
    {
      id: "messages",
      label: "",
      align: "center",
      type: "messageIndicator",
      width: "70px",
    },
  ],
};

export const myLeaveRequestsIsMobile = {
  id: "employees-list-table",
  select: "row",
  columns: [
    {
      id: "period",
      type: "text",
      label: "OC_PERIOD",
      sort: true,
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const allLeaveRequestsWithCoverage = {
  id: "all-leave-requests-with-coverage-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "title",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
      sortAccessor: "sortName",
    },
    {
      id: "typeName",
      type: "typeName",
      label: "OC_TYPE",
      sort: true,
      filter: true,
    },
    {
      id: "period",
      type: "text",
      label: "OC_PERIOD",
      sort: true,
    },
    {
      id: "workDays",
      type: "text",
      label: "MY_LEAVE_ABBREVIATED_WORKDAYS",
      align: "right",
      sort: true,
      width: "100px",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
      sort: true,
      filter: true,
    },
  ],
};

export const allLeaveRequestsWithCoverageIsMobile = {
  id: "all-leave-requests-with-coverage-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "65px",
    },
    {
      id: "title",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
      sortAccessor: "sortName",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
      sort: true,
      filter: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const userLeaveRequests = {
  id: "employees-list-table",
  select: "row",
  columns: [
    {
      id: "leaveTypeName",
      type: "leaveTypeName",
      label: "OC_TYPE",
      sort: true,
      filter: true,
    },
    {
      id: "period",
      type: "text",
      label: "OC_PERIOD",
      sort: true,
    },
    {
      id: "effectiveWorkDays",
      type: "text",
      label: "MY_LEAVE_ABBREVIATED_WORKDAYS",
      align: "right",
      sort: true,
      width: "100px",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
      sort: true,
    },
    {
      id: "createdAt",
      type: "text",
      label: "OC_REQUEST_CREATED_AT",
      sort: true,
    },
    {
      id: "messages",
      label: "",
      align: "center",
      type: "messageIndicator",
      width: "70px",
    },
  ],
};

export const userLeaveRequestsIsMobile = {
  id: "employees-list-table",
  select: "row",
  columns: [
    {
      id: "period",
      type: "text",
      label: "OC_PERIOD",
      sort: true,
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const orphanedLeaveRequests = {
  id: "my-leave-orphaned-leave-requests-table",
  select: "none",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "nameAndJobClass",
      label: "OC_NAME",
      sort: true,
      search: true,
      align: "left",
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      //width: "140px",
      sort: true,
      filter: true,
    },
    {
      id: "type",
      type: "localizedName",
      label: "OC_TYPE",
      //width: "140px",
      sort: true,
    },
    {
      id: "startDate",
      type: "periodAndWorkDays",
      label: "OC_PERIOD",
      sort: true,
    },
    {
      id: "leaveActions",
      type: "leaveActions",
      label: "",
      width: "120px",
    },
  ],
};

export const orphanedLeaveRequestsIsMobile = {
  id: "my-leave-orphaned-leave-requests-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "50px",
    },
    {
      id: "name",
      type: "nameAndJobClass",
      label: "OC_NAME",
      sort: true,
      search: true,
      align: "left",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const examinerDashboardSummary = {
  id: "examiner-dashboard-summary-table",
  select: "row",
  columns: [
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "40px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: true,
    },
    /*{
      id: "availableRoles",
      type: "availableRoles",
      label: "OC_ROLE",
      sort: true,
      filter: true,
      width: "135px",
      align: "left",
    },*/
    {
      id: "baseLeaveBar",
      type: "baseLeaveBar",
      label: "MY_LEAVE_NEW_LEAVE_BASE",
    },
    {
      id: "leaveBadges",
      type: "leaveBadges",
      label: "OC_REQUEST",
      width: "120px",
    },
  ],
};

export const examinerDashboardSummaryIsMobile = {
  id: "examiner-dashboard-summary-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "leaveBadges",
      type: "leaveBadges",
      label: "OC_REQUEST",
      filter: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const allLeaveRequestsDailyTable = {
  id: "all-leave-requests-daily-table",
  select: "row",
  rowSpan: true,
  rowSpanField: "date",
  dayFormat: "dddd",
  columns: [
    {
      id: "date",
      label: "OC_CALENDAR",
      type: "dateWithdayName",
      width: "200px",
      sort: true,
      rowSpan: true,
    },
    {
      id: "title",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
      rowSpan: true,
      sortAccessor: "sortName",
    },
    {
      id: "typeName",
      type: "typeName",
      label: "OC_TYPE",
      sort: true,
      filter: true,
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
      sort: true,
      filter: true,
    },
  ],
};
